import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const numericValue = z
  .union([z.number(), z.string()])
  .transform(value => Number(value))
  .refine(value => Number.isFinite(value), 'Valor numérico inválido')

export const heavyMachineryObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  title: z.string(),
  type: z.string(),
  plate: z.string().nullish(),
  patrimonyNumber: z.string(),
  year: z.number().int(),
  hourPrice: numericValue,
  observation: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const heavyMachineryCreateInputObject = z.object({
  id: z.string().uuid().nullish(),
  title: z.string().min(1),
  type: z.string().min(1),
  plate: z.string().nullish(),
  patrimonyNumber: z.string().min(1),
  year: z.number().int(),
  hourPrice: numericValue,
  observation: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export const heavyMachineryUpdateInputObject = z.object({
  id: z.string().uuid(),
  title: z.string().min(1).optional(),
  type: z.string().min(1).optional(),
  plate: z.string().nullable().optional(),
  patrimonyNumber: z.string().min(1).optional(),
  year: z.number().int().optional(),
  hourPrice: numericValue.optional(),
  observation: z.string().nullable().optional(),
  updatedAt: dateOrIsoString().nullish(),
})

export type HeavyMachineryType = z.infer<typeof heavyMachineryObject>

export const propertyMap = {
  id: sql`heavy_machinery.id`,
  code: sql`heavy_machinery.code`,
  title: sql`heavy_machinery.title`,
  type: sql`heavy_machinery.type`,
  plate: sql`heavy_machinery.plate`,
  patrimonyNumber: sql`heavy_machinery.patrimony_number`,
  year: sql`heavy_machinery.year`,
  hourPrice: sql`heavy_machinery.hour_price`,
  observation: sql`heavy_machinery.observation`,
  sourceFilter: sql`heavy_machinery.source_filter`,
  clientId: sql`heavy_machinery.client_id`,
  insertUserId: sql`heavy_machinery.insert_user_id`,
  editUserId: sql`heavy_machinery.edit_user_id`,
  createdAt: sql`heavy_machinery.created_at`,
  updatedAt: sql`heavy_machinery.updated_at`,
  deletedAt: sql`heavy_machinery.deleted_at`,
}
